import { useSubscription } from 'services/hooks';
import {
  FreeUserAIGenerationLimitDialog,
  PersonalUserAIGenerationLimitDialog,
  ProUserAIGenerationLimitDialog,
} from './components';

interface PropsType {
  isOpen: boolean;
  onClose: () => void;
}
const AIGenerationLimitDialog = ({ onClose, isOpen }: PropsType) => {
  const { isFreeAccount, isPersonalAccount, isProAccount } = useSubscription();
  if (isFreeAccount) {
    return (
      <FreeUserAIGenerationLimitDialog isOpen={isOpen} onClose={onClose} />
    );
  }

  if (isPersonalAccount) {
    return (
      <PersonalUserAIGenerationLimitDialog isOpen={isOpen} onClose={onClose} />
    );
  }

  if (isProAccount) {
    return <ProUserAIGenerationLimitDialog isOpen={isOpen} onClose={onClose} />;
  }

  return null;
};

export default AIGenerationLimitDialog;
